import { Component, ReactNode, createRef } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/atoms/HorizontalSlider/HorizontalSlider.css'

type HorizontalSliderProps = {
  slides: ReactNode[]
  current: number

  onSlideStart?: () => void
  onSlideEnd?: () => void
}

type HorizontalSliderState = {
  isAnimating: boolean
  current: number
}

type HorizontalSliderInnerProps = typeof HorizontalSlider.defaultProps & HorizontalSliderProps

class HorizontalSlider extends Component<HorizontalSliderProps, HorizontalSliderState> {
  static defaultProps = {
    onSlideStart: () => { /* do nothing */ },
    onSlideEnd: () => { /* do nothing */ },
  }

  static getDerivedStateFromProps (nextProps: HorizontalSliderProps, prevState: HorizontalSliderState) {
    if (prevState.current !== nextProps.current) {
      return { isAnimating: true }
    }
    return {}
  }

  state = {
    isAnimating: false,
    current: this.props.current,
  }

  private slideeRef = createRef<HTMLDivElement>()

  render () {
    const { slides, current } = this.props
    const { isAnimating } = this.state

    const translateValue = current * 100

    const rootClass = cn(styles.horizontalSlider, {
      [styles.animating]: isAnimating,
    })

    return (
      <section className={ rootClass }>
        { slides.map((slide, idx) => {
          const slideClass = cn(styles.slide, {
            [styles.other]: idx !== current,
          })

          const restProps = idx === 0 ? { ref: this.slideeRef } : {}

          return (
            <div
              key={ idx }
              className={ slideClass }
              style={{ transform: `translateX(${ -translateValue }%)` }}
              { ...restProps }
            >
              { slide }
            </div>
          )
        })}
      </section>
    )
  }

  componentDidMount () {
    const slideeNode = this.slideeRef.current
    if (slideeNode) {
      slideeNode.addEventListener('transitionend', this.handleTransitionEnd)
    }
  }

  componentDidUpdate (prevProps: HorizontalSliderProps) {
    if (this.props.current !== prevProps.current) {
      const { onSlideStart } = this.props as HorizontalSliderInnerProps
      onSlideStart()
    }
  }

  private handleTransitionEnd = (event: any) => {
    const slideeNode = this.slideeRef.current
    if (event.target !== slideeNode) {
      return
    }

    const { onSlideEnd } = this.props as HorizontalSliderInnerProps
    onSlideEnd()
    this.setState({ isAnimating: false })
  }
}

export default HorizontalSlider
